// extracted by mini-css-extract-plugin
module.exports = {"avitoStepDescription":"FormStepDescription_avitoStepDescription__DIjeu","descriptionDisabled":"FormStepDescription_descriptionDisabled__fjtaa"};